interface FreshnessBadgeProps {
  periodLabel: string;
  isSampleData: boolean;
  lastRefreshedAt: string | null;
}

export function FreshnessBadge({ periodLabel, isSampleData, lastRefreshedAt }: FreshnessBadgeProps) {
  return (
    <div className={`freshness-badge ${isSampleData ? 'freshness-badge--sample' : ''}`}>
      <span>Period: {periodLabel}</span>
      <span aria-hidden>&middot;</span>
      <span>{isSampleData ? 'SAMPLE DATA -- replace files in /data-snapshots before production use' : 'Live snapshot'}</span>
      {lastRefreshedAt && (
        <>
          <span aria-hidden>&middot;</span>
          <span>Checked {new Date(lastRefreshedAt).toLocaleTimeString()}</span>
        </>
      )}
    </div>
  );
}
